import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';
import {responseResolveInterceptor} from './interceptors';

export function getMemberWalletReplenish({giftId}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/wallet/replenish/',
        method: 'get',
        params: {...addAuthTokenData({giftId})}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberWalletReplenish.js